import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./register.css";
import RegisterModel from "./registerModel";
import { useFormik } from "formik";
import * as Yup from "yup";
import { register } from "../../store/auth/register";
import { AXIOS, api_key } from "../../config";
import Loader from "../loader/loader";
import { toast } from "react-toastify";
import { MdEmail, MdSms, MdOutlineArrowDropDown } from "react-icons/md";
import "react-phone-number-input/style.css";
import { PhoneInput } from "react-contact-number-input";
import AntTabs from "../login/antDesignSign/AntTabs";
import { useDispatch } from "react-redux";
import {updatePath} from '../../store/auth/auth'
export default function Register() {
  const [referral, setReferral] = useState(false);
  
  const handleReferral = () => {
    setReferral(!referral);
  };
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isLoading, setLoading] = useState<Boolean>(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const registerSchema = Yup.object().shape({
    registerType: Yup.string(),
    email: Yup.string()
      .min(0)
      .required("Email is required").email('Please! Enter a valid email address'),
    phoneNumber: Yup.object().shape({
      phone: Yup.string(),
      country: Yup.string(),
    }),
    password: Yup.string()
      .min(8)
      .required("Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
        " at least one uppercase letter, one lowercase letter and one number"
      ),
    refId: Yup.string().min(0),
  });
  const formik = useFormik({
    initialValues: {
      registerType: "email",
      phoneNumber: {
        country: "",
        phone: "",
      },
      password: "",
      refId: "",
      email:'',
      isAgree: false,

    },
    validationSchema: registerSchema,

    onSubmit: async (values, action) => {
      console.log('formik.values',formik.values.email)
      setLoading(true);
      if (values.registerType == "email") {
        let ceheckuser=await AXIOS.post('/checkUserRegister',{
          api_key:api_key,
          registerType:values.registerType,
          data:values.email,
          reffer:values.refId|| null
        })
        console.log('checkuser',ceheckuser)
        if(ceheckuser.data.status=='success'){
          await AXIOS.post(`/sendMailPin`, {
            api_key: api_key,
            email: values.email,
          })
            .then((response) => {
              toast.success(response.data.showableMessage, { icon: <MdEmail /> });
              if (response.data.status == "success") {
                handleShow();
              }
              setLoading(false);
            })
            .catch((error) => {
              toast.error("Email not sent", { icon: <MdEmail /> });
              setLoading(false);
            });
        }
        else{
          
          toast.error(ceheckuser.data.showableMessage)
          setLoading(false);

        }
       
      } else {
        return 0
        await AXIOS.post(`/sendSMSPin`, {
          api_key: api_key,
          country_code: values.phoneNumber.country,
          phone: values.phoneNumber.phone,
        })
          .then((response) => {
            toast.success(response.data.showableMessage, { icon: <MdSms /> });
            if (response.data.status == "success") {
              handleShow();
            }
            setLoading(false);
          })
          .catch((error) => {
            toast.error("Sms not sent", { icon: <MdSms /> });
            setLoading(false);
          });
      }

      dispatch(register(values));
    },
  });
  {
    console.log(formik.errors);
  }
  const handlePhone = (value: any) => {
    formik.setFieldValue("phoneNumber", {
      country_code: value.countryCode,
      phone: value.phoneNumber,
    });
    formik.setFieldError("phoneNumber", value.message);
  };
  
  return (
    <>
      <div className="mx-auto w-50 reg_main">
        {
          !show &&  <div className="container register-bg mt-5 mb-5 py-2">
          <div className="row">
            <div className="col-12 mb-2">
              <h2 className="register-heading ">Create VirtualEX Account</h2>
              <span className="">Register with your email or mobile</span>
            </div>
          </div>
          <div className="row ">
            <form className="" onSubmit={formik.handleSubmit}>
              <div className="col-12 col-md-8 mt-2">
                <AntTabs   formik={ formik}/>
              </div>
              <div className="form-group col-12 col-md-8 mt-2">
                <label htmlFor="" className="mb-2 label_reg">
                  Password
                </label>
                <input
                  type="password"
                  name="password"
                  className="form-control p-2"
                  id="password"
                  placeholder="Password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                />
                {formik.errors.password && (
                  <div id="password" className="text-danger">
                    {formik.errors.password}
                  </div>
                )}
              </div>
              <div className="form-group col-12 col-md-8 mt-2">
                <label htmlFor="" onClick={handleReferral} className="mb-2 label_reg">
                  Referral ID (Optional) <MdOutlineArrowDropDown />{" "}
                </label>
                {referral && (
                  <input
                    type="text"
                    name="refId"
                    className="form-control p-2"
                    placeholder="Referral ID"
                    value={formik.values.refId}
                    onChange={formik.handleChange}
                  />
                )}
              </div>
              <div className=" col-sm-12 col-md-8 mt-2 d-flex justify-content-start">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="isAgree"
                    id="flexRadioDefault1"
                    
                    onChange={formik.handleChange}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault1"
                  >
                    I have read and agree to
                  </label>
                </div>
              </div>
              <div className="col-12 col-md-8">
                {isLoading == false ? (
                  <div className="d-grid gap-2">
                    <button className="btn btn-register mt-2" type="submit" disabled={ !formik.dirty||(Boolean(formik.errors.email || formik.errors.password || formik.values.isAgree==false))}>
                      Register
                    </button>
                  </div>
                ) : (
                  <div className="d-grid gap-2">
                  <button className="btn btn-register"><Loader /></button>
                  
                </div>
                )}
              </div>
            </form>
          </div>
          <div className="row mt-2 pb-5">
            <div className="col-6 d-flex justify-content-start align-items-center">
              <span className="form-check-label">
                Already registered? &nbsp;
              </span>
              <a
                className="link-login"
                onClick={() => {
                  navigate("/login");
                  dispatch(updatePath('login'))
                }}
              >
                Login
              </a>
            </div>
          </div>
        
        </div>
        }
       
       
      </div>
      {
          show&&<RegisterModel show={show} handleClose={handleClose} />
         } 
    </>
  );
}